import React from 'react';
import { IRifa } from '../../types/rifa';
import { isRifaBloqueada, convertDataSorteio, chegouDataSorteio } from '../../utils/FunctionUtils';
import { RifaStatus } from '../../constants';
import ComprarRifa from './ComprarRifa';
import Loading from '../../components/Loading';

interface Props {
   rifa: IRifa;
   codigoAfiliacao?: string;
   loading?: boolean;
   numRotacoes?: number;
   chegouDataSorteio: boolean;
}

const CapaRifa: React.FC<Props> = (props) => {
   const { rifa, codigoAfiliacao } = props;
   const currencyFormat = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' };
   const valorUnitario = rifa.valorUnitario ? rifa.valorUnitario : 0;

   let imgSrc = undefined;
   if (rifa.fotoOrganizador) imgSrc = `data:image/png;base64,${rifa.fotoOrganizador}`;
   else if (rifa.pathFotoOrganizador) imgSrc = rifa.pathFotoOrganizador;
   else imgSrc = `${process.env.PUBLIC_URL}/images/rifa-logo-150x150.png`;

   return (
      <section id="testimonials5-ny" className="mb-0">
         {/* Imagem de capa */}
         <div id="rifa-cover-img">
            {
               // Descricao do status da rifa
               rifa.status && rifa.descricaoStatus && isRifaBloqueada(rifa.status) ? (
                  <div className="text-center pt-4">
                     <h2 className="title-common title-secondary">A campanha está {rifa.descricaoStatus}</h2>
                  </div>
               ) : null
            }
         </div>

         {/* Imagem do organizador */}
         <div className="d-flex">
            <img
               src={imgSrc}
               style={{
                  transform: props.numRotacoes ? `rotate(${props.numRotacoes * 90}deg)` : '',
                  WebkitTransform: props.numRotacoes ? `rotate(${props.numRotacoes * 90}deg)` : '',
                  msTransform: props.numRotacoes ? `rotate(${props.numRotacoes * 90}deg)` : '',
                  OTransform: props.numRotacoes ? `rotate(${props.numRotacoes * 90}deg)` : '',
               }}
               className="img-organizador"
               alt="Organizador da Campanha"
            />
         </div>

         {props.loading ? (
            <div className="mt-4">
               <Loading />
            </div>
         ) : (
            <div className="text-center padding-x mt-2">
               {/* Nome do beneficiário */}
               <h5 id="nome-beneficiado" style={{ color: '#444444' }}>
                  {rifa.nomeBeneficiado}
               </h5>

               {/* Valor da rifa */}
               <div>Valor da rifa: {valorUnitario.toLocaleString('pt-BR', currencyFormat)}</div>

               {/*Data da Rifa e Nome do Organizador */}
               <div>
                  Data do sorteio: {rifa.dataEncerramento ? convertDataSorteio(rifa.dataEncerramento) : '00/00/0000'}
                  <br />
                  Organização: {rifa.nomeOrganizador}
               </div>

               {/* Botão de comprar */}
               {
                  // Verifica se o status é válido
                  (rifa.status === RifaStatus.APROVADO) &&
                  !chegouDataSorteio(rifa.dataEncerramento) &&
                  !props.chegouDataSorteio ? (
                     <ComprarRifa rifa={rifa} codigoAfiliacao={codigoAfiliacao} />
                  ) : (
                     <br />
                  )
               }

               {/* Objetivo */}
               <div style={{ lineHeight: '1.5', fontSize: '1.2rem' }}>{rifa.objetivo}</div>
            </div>
         )}
      </section>
   );
};

export default CapaRifa;
